import {
	GET_VIDEO_DETAIL_START, GET_VIDEO_DETAIL, GET_VIDEO_PLAYLIST_START, GET_VIDEO_PLAYLIST,
	RESET_VIDEO_PLAYLIST,
} from '../constants';

const initialState = {};

const video = (state = initialState, {type, seoName, data}) => {
	switch (type) {
		case GET_VIDEO_DETAIL_START:
			return {
				...state,
				[seoName]: {
					...state[seoName],
					detail: {
						data: null,
						isLoading: true,
					},
				},
			};
		case GET_VIDEO_DETAIL: {
			let info = null;
			if (JSON.stringify(data) === '{}') {
				info = {
					seoName,
					code: 'Failed',
				};
			} else if (data && data.code && data.code.toLowerCase() === 'failed') {
				info = {
					seoName,
					code: 'Failed',
				};
			} else if (data && data.code && data.code.toLowerCase() === 'failedgeo') {
				info = {
					seoName,
					noAccess: true,
					code: 'Blackout',
				};
			} else {
				// Set noAccess with undefined
				info = {
					seoName,
					...data,
					noAccess: undefined,
					code: data.blackout ? 'Blackout' : undefined,
				};

				// delete useless detail info
				if (info.bundlePurchases) {
					delete info.bundlePurchases;
				}
				if (info.relatedCategory) {
					delete info.relatedCategory;
				}
				if (info.relatedKeyword) {
					delete info.relatedKeyword;
				}
			}
			return {
				...state,
				[seoName]: {
					...state[seoName],
					detail: {
						data: info,
						isLoading: false,
					},
				},
			};
		}
		case GET_VIDEO_PLAYLIST_START:
			return {
				...state,
				[seoName]: {
					...state[seoName],
					playlist: {
						...data,
					},
				},
			};
		case GET_VIDEO_PLAYLIST: {
			return {
				...state,
				[seoName]: {
					...state[seoName],
					playlist: {
						...state[seoName].playlist,
						...data,
					},
				},
			};
		}
		case RESET_VIDEO_PLAYLIST: {
			return {
				...state,
				[seoName]: {
					...state[seoName],
					playlist: {},
				},
			};
		}
		default:
			return state;
	}
};

export default video;
